export default "__VITE_ASSET__Um$WzFs8__"